export default __webpack_public_path__ + "static/media/loginScreenshot.8f24ecb6.png";